export default __webpack_public_path__ + "static/media/weibo.d7f480be.jpg";